import type { RootState } from '../root-reducer';

export const selectContentCategoriesCatalog = (state: RootState) => state.contentCategories.catalog;
export const selectContentCategoriesFetching = (state: RootState) => state.contentCategories.fetching;
